<template>
    <div class="EasylunchUserOverview" v-if="isLoaded">

        <template v-if="!suscripciones.length">
            <b-jumbotron header="No hay información">
                Éste usuario no participa en el programa Easy Lunch
            </b-jumbotron>
        </template>

        <template v-else-if="suscripciones">

            <h1>Inscripciones</h1>
            <b-table responsive :fields="captionsForUserEmpresa" :items="suscripciones">
                <template #cell(_)="data">
                    <preseancia-easylunch-automodal :conceptId="data.item.id" :tipo-default="data.item.tipo" />
                </template>
            </b-table>

            <template v-if="loncheras.length">
                <h1>Loncheras</h1>
                <b-table responsive :fields="captionsForUserEscuela" :items="loncheras">
                    <template #cell(_)="data">
                        <preseancia-easylunch-automodal :conceptId="data.item.id" :tipo-default="data.item.tipo" />
                    </template>
                </b-table>
            </template>

        </template>

        <!-- 
        <hr>
        <b-button>
            Vincular con escuela o empresa
        </b-button> 
        -->
    </div>
</template>

<script>
import _ from 'lodash'
import { getEasyLunchDeUsuario } from './Easylunch'
import { captionsForUserEmpresa, captionsForUserEscuela } from './Presencias/archetype'
import preseanciaEasylunchAutomodal from '../Easylunch/Presencias/automodal.vue'

export default {
    name: 'EasylunchUserOverview',
    components: {preseanciaEasylunchAutomodal},
    props: {
        usuariosId: {
            type: [Number, String],
            required: true
        }
    },
    data: () => {
        return {
            isLoaded: false,
            isProcessing: false,
            captionsForUserEmpresa, captionsForUserEscuela,
            data: {
                lunchpresencias: []
            }
        }
    },
    computed: {
        suscripciones(){
            return _.filter(this.data.lunchpresencias, {tipo: 'directo'})
        },
        loncheras(){
            return _.filter(this.data.lunchpresencias, {tipo: 'alumno'})
        },
    },
    async mounted(){
        this.isLoaded = false;
        let response = await getEasyLunchDeUsuario(this.usuariosId);
        if(response){
            this.data.lunchpresencias = response.data.lunchpresencias;
        }
        this.isLoaded = true;
        console.debug(response)
    }
}
</script>

<style lang="less">
    .EasylunchUserOverview {

    }
</style>